/**
 * @desc 下架首页横幅
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type RevokeBannerParameter = {
  id?: string
}

const method = 'PUT'
const url = '/content/operation/banner/revoke'

export const revokeBannerApi = (
  params?: RevokeBannerParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    params,
    ...config
  })
}

revokeBannerApi.method = method
revokeBannerApi.url = url
